import {
  Brand,
  Button,
  Chip,
  Division,
  Flex,
  Heading,
  Paragraph,
} from "@ir/ui";
import { useNavigate } from "react-router";
import type { IOrganizationProps } from "@src/domain/entities/organization/Organization";

export interface OrganizationCardHeaderProps {
  organization: IOrganizationProps;
}

export const OrganizationCardHeader = ({
  organization,
}: OrganizationCardHeaderProps) => {
  const navigate = useNavigate();
  const displayName =
    organization.organizationDisplayName ?? organization.organizationName;
  const brands = organization.brands ?? [];
  const activeBrandCount = brands.filter(
    (brand) => brand.brandIsActive === true && brand.brandDeletedAt === null,
  ).length;
  const activeBrandLabel = activeBrandCount === 1 ? "brand" : "brands";

  return (
    <Flex align="center">
      <Brand
        brandName={displayName}
        logoSrcCompact={organization.organizationLogoUrl ?? undefined}
      />
      <Division style={{ marginLeft: "0.75rem", flex: 1 }}>
        <Heading level={6} className="text-grey-700 font-bold m-0">
          <Button
            size="small"
            noStyle
            htmlTitle="View Organization Details"
            className="link-button"
            onPress={() =>
              navigate(`/organizations/${organization.organizationKey}`, {
                state: {
                  organizationId: organization.organizationId,
                  organization,
                },
              })
            }
          >
            {displayName}
          </Button>
        </Heading>
        <Paragraph className="m-0 text-grey-500 font-regular">
          {activeBrandCount} Active {activeBrandLabel}
        </Paragraph>
      </Division>
      <Flex align="center" gap={0.375}>
        {!organization.organizationIsActive && (
          <Chip size="small" label="Inactive" color="warning" borderless />
        )}
        {organization.organizationDeletedAt !== null && (
          <Chip size="small" label="Deleted" color="error" borderless />
        )}
        {organization.organizationIsActive &&
          organization.organizationDeletedAt === null && (
            <Chip size="small" label="Active" color="success" borderless />
          )}
      </Flex>
    </Flex>
  );
};
